import { prop } from 'ramda';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useAppSelector } from 'js/store/hooks';
import { storageService } from 'js/services/storage.service';
import { languageService } from 'js/services/language.service';

import * as actions from '../../../store/actions';

export const useSetUserLang = () => {
    const userDispatch = useDispatch();
    const defaultLocale = useAppSelector(prop('defaultLocale')) || languageService.defaultLocale;
    const allowedLocales = useAppSelector(prop('allowedLocales'));

    return useCallback((lang) => {
        const isLangAllowed = allowedLocales.includes(lang);
        const language = isLangAllowed ? lang : defaultLocale;

        userDispatch(actions.setLangAction(language));
        storageService.local.setItem('userLang', language);
    }, [allowedLocales, defaultLocale, userDispatch]);
};
